// 获取用户信息
export const getUserInfo = () => {
  const userInfo = localStorage.getItem('user');
  return userInfo ? JSON.parse(userInfo) : null;
};

// 设置用户信息
export const setUserInfo = (userInfo:any) => {
  localStorage.setItem('user', JSON.stringify(userInfo));
};

// 获取用户权限（兼容旧版本）
export const getUserPermissions = () => {
  const userInfo = getUserInfo();
  return userInfo ? userInfo.permissions || [] : [];
};

// 获取用户菜单
export const getUserMenus = () => {
  const userInfo = getUserInfo();
  return userInfo ? userInfo.menus || [] : [];
};

// 获取权限信息（基于新的RBAC结构）
export const getPermissionInfo = () => {
  const userInfo = getUserInfo();
  return userInfo?.permission_info || { modules: [] };
};

// 判断用户是否有功能权限（基于 func_id）
export const hasPermission = (funcId: string): boolean => {
  const permissionInfo = getPermissionInfo();
  const modules = permissionInfo.modules;
  if (!modules || modules.length === 0) {
    return false;
  }

  // 递归遍历嵌套权限树（一级模块 → 二级模块 → 功能点），判断是否存在某 func_id
  const contains = (node: any): boolean => {
    if (!node) return false;
    if (node.func_id === funcId) return true;
    if (Array.isArray(node.children)) return node.children.some(contains);
    // 兼容旧的扁平 functions 结构
    if (Array.isArray(node.functions)) return node.functions.some(contains);
    return false;
  };

  return modules.some(contains);
};

// 判断用户是否有权限访问某个菜单
export const canAccessMenu = (menuPath) => {
  const menus = getUserMenus();
  // return menus.some(menu => menu.routePath === menuPath || menu.children?.some(child => child.path === menuPath));
   // 检查顶级菜单和子菜单的path字段，而不是routePath
  return menus.some(menu => menu.path === menuPath || menu.children?.some(child => child.path === menuPath));
};

// 获取用户菜单中第一个可访问的叶子路由（用于权限不足时的兜底跳转，避免死循环）
export const getFirstAccessibleRoute = (): string => {
  const menus = getUserMenus();
  for (const menu of menus) {
    if (menu.path) return menu.path;
    if (Array.isArray(menu.children)) {
      for (const child of menu.children) {
        if (child.path) return child.path;
      }
    }
  }
  return "";
};

// 移除Token
export const removeToken = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('access_token');
};
